import * as User from '../../constants/User/SignIn'
import axios from 'axios';

import * as SG from '../../constants/AppSettings'
import { signInCheck, noticeAdd, loadEnd, loadStart } from '../App';

export function signInCheckForSns() {
  return dispatch => {
    dispatch(signInCheck())
  }
}

export function facebookSignInRequest() {
  return {
    type: User.USER_FACEBOOK_SIGN_IN_REQUEST
  }
}

// export function facebookSignInResult(access_token) {
//   return {
//     type: User.USER_FACEBOOK_SIGN_IN_RESULT,
//     access_token,
//   }
// }

export function facebookSignInResult(access_token) {
  if (access_token) {
    window.localStorage.setItem('token', access_token);
    // dispatch(signInCheck())

    return dispatch => {
      dispatch(signInCheck())
      dispatch(noticeAdd('Facebook認証に成功しました', 'success'))
      return {
        type: User.USER_FACEBOOK_SIGN_IN_RESULT,
        access_token
      }
    }
  } else {
    return {
      type: User.USER_FACEBOOK_SIGN_IN_RESULT,
      access_token
    }
  }
}


export function facebookSignIn() {

  return dispatch => {
    dispatch(facebookSignInRequest());
    dispatch(loadStart());

    window.FB.getLoginStatus((response) => {
      if (response.status === 'connected') {
        axios.post(SG.FACEBOOK_SIGN_IN_URL, response).then((r) => {
          window.localStorage.setItem('token', r.data.access_token);
          //サインインチェックをかける
          dispatch(signInCheck())
          dispatch(facebookSignInResult(r.data.access_token))
          dispatch(loadEnd())
          dispatch(noticeAdd('Facebookログイン成功', 'success'))
        }).catch(
          (r) => {
            dispatch(facebookSignInResult(false))
            dispatch(loadEnd())
            dispatch(noticeAdd('Facebookログイン失敗', 'error'))
          }
        );;
        return {
          type: User.USER_TWITTER_SIGN_IN
        };
      }
      window.FB.login((res) => {
        axios.post(SG.FACEBOOK_SIGN_IN_URL, res).then((r) => {
          window.localStorage.setItem('token', r.data.access_token);
          dispatch(loadEnd());
          //サインインチェックをかける
          dispatch(signInCheck())
          dispatch(facebookSignInResult(r.data.access_token))
          dispatch(noticeAdd('Facebookログイン成功', 'success'))
        }).catch(
          (r) => {
            // console.log('FBログインエラー2:', r)
            dispatch(loadEnd());
            dispatch(facebookSignInResult(false))
          }
        );
      });
      return {
        type: User.USER_TWITTER_SIGN_IN
      };
    });

  }
}

// export function twitterTokenSignIn(token) {
//   return dispatch => {
//     dispatch(loadStart())
//     if (token) {
//       window.localStorage.setItem('token', token)
//       dispatch(noticeAdd('Twitter認証に成功しました', 'success'))
//     } else {
//       dispatch(noticeAdd('Twitter認証に失敗しました', 'error'))
//     }
//     dspsatch(loadend())
//   }
// }


// export function twitterSignIn() {

//   return dispatch => {
//     dispatch(loadStart())
//     dispatch(twitterSignInRequest());

//     axios.get(SG.TWITTER_TOKEN_URL).then((r) => {
//       let token = r.data.oauth_token

//       const url = SG.TWITTER_API_URL + `?oauth_token=${token}`

//       console.log('Twitter Sign In', r, token, url)

//       twitterSignInResult(token)
//       const windowLogin = window.open(url)
//       // setTimeout(function () {
//       //   CheckLoginStatusTwitter(dispatch(history))
//       // }, 1000)
//       if (!!windowLogin) {
//         windowLogin.focus()
//       }
//     }).catch((r) => {
//       dispatch(noticeAdd('Twitterログイン失敗', 'error'))
//       dispatch(loadEnd())
//     });
//   }
// }

// export function twitterSignInToServer(params) {
//   return dispatch => {
//     dispatch(loadStart())
//     axios.post(SG.TWITTER_SIGN_IN_URL, params).then((r) => {

//       console.log('Sign in to server', params, r)

//         window.localStorage.setItem('token', r.data.access_token);
//         //サインインチェックをかける
//         dispatch(signInCheck())
//         dispatch(twitterSignInResult(r.data.access_token))
//         dispatch(loadEnd())
//         dispatch(noticeAdd('Twitter ログイン成功', 'success'))

//     }).catch((r) => {
//       dispatch(noticeAdd('失敗','error'))
//       dispatch(loadEnd())

//       })
//   }
// }

export function twitterSignInRequest() {
  return {
    type: User.USER_TWITTER_SIGN_IN_REQUEST
  }
}

export function twitterSignInResult(access_token) {
  if (access_token) {
    window.localStorage.setItem('token', access_token);
    // dispatch(signInCheck())

    return dispatch => {
      dispatch(signInCheck())
      dispatch(noticeAdd('Twitter認証に成功しました', 'success'))
      return {
        type: User.USER_TWITTER_SIGN_IN_RESULT,
        access_token
      }
    }
  } else {
    return {
      type: User.USER_TWITTER_SIGN_IN_RESULT,
      access_token
    }
  }
}






export function googleSignIn(history) {
  return dispatch => {
    dispatch(googleSignInRequest());


    var state_token = localStorage.getItem('google_state_token')
      state_token = String(new Date().getTime());
      localStorage.setItem('google_state_token', state_token)


    var googleUrl = SG.GOOGLE_API_URL + state_token


    const windowLogin = window.open(googleUrl)
    windowLogin.focus()

  }
}

export function googleSignInToServer(params) {
  return dispatch => {
    dispatch(loadStart())
    const code = params.replace(/\?code=/, '')
    // console.log('グーグルサーバー',code)
    axios.post(SG.GOOGLE_SIGN_IN_URL, {
      code: code
      }).then((r) => {
        window.localStorage.setItem('token', r.data.access_token);
        // console.log('サーバーレスポンス', r)
        //サインインチェックをかける
        dispatch(signInCheck())
        dispatch(googleSignInResult(r.data.access_token))
        dispatch(loadEnd())
        dispatch(noticeAdd('Google ログイン成功', 'success'))
      return {
        type: User.USER_GOOGLE_SIGN_IN_TO_SERVER
      }
    }).catch((r) => {
      // console.log('サーバーレスポンス', r)
      dispatch(noticeAdd('失敗','error'))
      dispatch(loadEnd())
      return {
        type: User.USER_GOOGLE_SIGN_IN_TO_SERVER
      }
      })
  }
}

export function googleSignInRequest() {
  return {
    type: User.USER_GOOGLE_SIGN_IN_REQUEST
  }
}

export function googleSignInResult(access_token) {
  if (access_token) {
    window.localStorage.setItem('token', access_token);
    // dispatch(signInCheck())
    return dispatch => {
      dispatch(signInCheck())
      dispatch(noticeAdd('Google認証に成功しました', 'success'))
      return {
        type: User.USER_GOOGLE_SIGN_IN_RESULT,
        access_token
      }
    }
  } else {
    return {
      type: User.USER_GOOGLE_SIGN_IN_RESULT,
      access_token
    }
  }
  
}

// export const twitterSignIn = createAction(User.USER_TWITTER_SIGN_IN);
// export const googleSignIn = createAction(User.USER_GOOGLE_SIGN_IN);


// WEBPACK FOOTER //
// ./src/actions/User/SignIn.js